<template>
    <table class="mx-auto table-border page">
        <thead>
            <tr>
                <th class="text-center" colspan="6">THÔNG TIN PHÒNG</th>
                <th class="text-center" colspan="100%">SỐ {{ type_text.toUpperCase() }} THÁNG {{ chosen_month_locale }}</th>
            </tr>
            <tr>
                <th class="text-center">STT</th>
                <th class="text-center">PHÒNG</th>
                <th class="text-center">SỐ NGƯỜI</th>
                <th class="text-center">MÁY GIẶT</th>
                <th class="text-center">MÁY LẠNH</th>
                <th class="text-center">ĐẦU KÌ</th>
                <th class="text-center">ĐẦU CUỐI KÌ</th>
                <th class="text-center">GHI CHÚ</th>
                <th class="text-center">NGÀY GHI</th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="(item, index) in room_data"
                :key="item.room_id"
            >
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ item.room_id }}</td>
                <td class="text-center"> {{ item.customer_count }}</td>
                <td class="text center">{{ item.washing_machine ? "Có" : "Không" }}</td>
                <td class="text-center">{{ item.air_conditioner ? "Có" : "Không" }}</td>
                <td class="text-center">{{ item.start_count }}</td>
                <td class="text-center">{{ item.end_count }}</td>
                <td class="text-left">{{ item.note }}</td>
                <td></td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        room_data: {
            type: Array,
            default: [],
        },
        type_text: String,
        chosen_month_locale: String
    },
    name: "print-electric-water",
    data(){
        return {}
    }
};
</script>

<style>
</style>